// Check minimum de quantité
function miniQuantity() {
  if (!!document.querySelector("#quantite-mini") === true){
    var total = parseInt(document.querySelector('.product .product-form__input label.total-nb .total-number').textContent);
    var minimumQuantity = parseInt(document.querySelector("#quantite-mini").textContent);
    if ( minimumQuantity <= total ){
      document.querySelector('.manque-quantite').style.cssText = "display: none;";
      document.querySelector('.product .product-form__input label.total-nb .total-number').style.cssText = "color: #000000;";
      if (!!document.querySelector('.product .btn-ajouter-au-devis[disabled]') === true){
        document.querySelector('.product .btn-ajouter-au-devis[disabled]').removeAttribute("disabled");
      }
    }else{
      document.querySelector('.product .btn-ajouter-au-devis').setAttribute("disabled", "true");
      document.querySelector('.manque-quantite').style.cssText = "display: block;";
      document.querySelector('.product .product-form__input label.total-nb .total-number').style.cssText = "color: #FF7530;";
    }
  }
}
miniQuantity();


// Quantité produit dans panier
function nbProduitPanier() {
  if (!!document.querySelector("#app-quotes #omgrfq_button_action_snap button.omgrfq_view_quote") === true){
    var textQuoteBtn = document.querySelector("#app-quotes #omgrfq_button_action_snap button.omgrfq_view_quote").textContent;
    document.querySelector(".cart-count-bubble span").textContent = textQuoteBtn.replace('View Quote (', '').replace(')', '');
  }
}


// Ajout des "faux" boutons dans le devis
function addSecondaryBtn() {
  document.querySelector("#omgrfq-submit-quote-form .form-group.button-submit-quote").insertAdjacentHTML("afterbegin", '<a href="https://legoodgoodies.fr/collections/tous-les-produits" class="ajouter-autres-produits">Ajouter d\'autres produits</a><div class="valider-devis">Valider mon devis</div>');
  document.querySelector("#omgrfq-submit-quote-form .form-group.button-submit-quote .valider-devis").onclick = function() {
    document.querySelector("html #omgrfq-submit-quote-form .omgrfq-form-wrapper .omgrfq-form").style.cssText = "display: flex;";
    document.querySelector("html .omgrfq-popup.omgrfq-popup-snap #submitOMGRFQForm").style.cssText = "display: block;";
    document.querySelector("#omgrfq-submit-quote-form .form-group.button-submit-quote .valider-devis").style.cssText = "display: none;";
    document.querySelector("#omgrfq-submit-quote-form .form-group.button-submit-quote .ajouter-autres-produits").style.cssText = "display: none;";
    
    const scrollContainer = document.querySelector('.omgrfq-content-scroll');
    const formElement = document.querySelector('.omgrfq-form');
    const scrollPosition = scrollContainer.scrollTop + (formElement.getBoundingClientRect().top - scrollContainer.getBoundingClientRect().top);
    scrollContainer.scrollTo({ top: scrollPosition, behavior: 'smooth' });
  };
  /*document.querySelector("#omgrfq-submit-quote-form .form-group.button-submit-quote .ajouter-autres-produits").onclick = function() {
    document.querySelector("html .omgrfq-popup.omgrfq-popup-snap .omgrfq_continue_shopping").click();
  };*/
}


// Calcul du nombre minimum de produits
function changeNb() {
  var total = 0;
  document.querySelectorAll('.product .product-form__input:not(.couleur-variants):not(.product-form__quantity) label input[type="number"]').forEach(function(input) {
    total += parseFloat(input.value) || 0;
  });
  document.querySelector('.product .product-form__input:not(.couleur-variants):not(.product-form__quantity) label.total-nb .total-number').textContent = total;
  miniQuantity();
  event.preventDefault();
  let scrollPosition = window.scrollY;
  setTimeout(function () {
    window.scrollTo({top: scrollPosition, behavior: 'auto'});
  }, 10);
  setTimeout(function () {
    window.scrollTo({top: scrollPosition, behavior: 'auto'});
  }, 70);
}


// Activer le block de recherche
function activeSearch() {
  var width_screen = window.innerWidth;
  if (width_screen > 1600) {
    document.querySelector("details-modal.header__search details").setAttribute("open", "true");
  }else if (!!document.querySelector('details-modal.header__search details[open]') === true){
    document.querySelector("details-modal.header__search details").removeAttribute("open");
  }
}
activeSearch();
window.onresize = activeSearch;



const checkElementPresence = (selector) => {
  return new Promise((resolve, reject) => {
    const startTime = Date.now();
    const timeout = 5000;
    const interval = 200;
    
    const checkElement = () => {
      const element = document.querySelector(selector);
      
      if (element) {
        clearInterval(intervalId);
        resolve(element);
      } else if (Date.now() - startTime >= timeout) {
        clearInterval(intervalId);
        reject(new Error(`Element "${selector}" not found within ${timeout}ms`));
      }
    };
    
    const intervalId = setInterval(checkElement, interval);
  });
};


// Gestion du plugin Quote
window.addEventListener("load", (event) => {
  document.querySelector("span.header__icon.header__icon--cart").onclick = function() {
    document.querySelector("#app-quotes .omgrfq_view_quote").click();
    setTimeout(function () {
      document.addEventListener('click', function(event) {
        if (event.target.closest('#quote-data')) {
          setTimeout(function () {
            nbProduitPanier();
          }, 500);
        }
      });
    }, 500);

    checkElementPresence('#submitOMGRFQForm')
    .then(element => {
      document.querySelector("#submitOMGRFQForm").onclick = function() {
        const submitBtn = document.querySelector("#submitOMGRFQForm");
        
        if (submitBtn.hasAttribute('disabled')) {
          submitBtn.removeAttribute('disabled');
          setTimeout(function() {
            submitBtn.click();
            checkElementPresence('.omgrfq-submit-success')
            .then(element => {
              window.location.replace("https://legoodgoodies.fr/pages/merci");
            })
            .catch(error => {
              console.error(error.message);
            });
          }, 300);
          return;
        }
        
        checkElementPresence('.omgrfq-submit-success')
        .then(element => {
          window.location.replace("https://legoodgoodies.fr/pages/merci");
        })
        .catch(error => {
          console.error(error.message);
        });
      };
    })
    .catch(error => {
      console.error(error.message);
    });

    setTimeout(function () {
      addSecondaryBtn();
    }, 0);
  };
  
  nbProduitPanier();

  if (!!document.querySelector(".omgrfq-button .omgrfq-btn-quotes") === true){
    document.querySelector(".omgrfq-button .omgrfq-btn-quotes").onclick = function() {
      setTimeout(function () {
        nbProduitPanier();
      }, 1000);
    };
  }

  if (!!document.querySelector("html .omgrfq-popup.omgrfq-popup-snap .omgrfq_continue_shopping") === true){
    document.querySelector("html .omgrfq-popup.omgrfq-popup-snap .omgrfq_continue_shopping").onclick = function() {
      nbProduitPanier();
    };
  }

  if (!!document.querySelector("html .omgrfq-bg") === true){
    document.querySelector("html .omgrfq-bg").onclick = function() {
      nbProduitPanier();
    };
  }
});


// Click sur Ajouter au devis
if (!!document.querySelector(".product .btn-ajouter-au-devis.has-only-default-variant") === true){
  document.querySelector(".product .btn-ajouter-au-devis.has-only-default-variant").onclick = function() {
    if (!document.querySelector(".product .btn-ajouter-au-devis:not([disabled])").hasAttribute('disabled')) {
      var qtyProduct = parseInt(document.querySelector(".product .product-form__input:not(.couleur-variants):not(.product-form__quantity) label.total-nb .total-number").textContent);
      document.querySelector(".product .product-form__input.product-form__quantity input.quantity__input").value = qtyProduct;
      document.querySelector(".product .omgrfq-button .omgrfq-btn-quotes").click();
      setTimeout(function () {
        addSecondaryBtn();
      }, 0);
      checkElementPresence('#submitOMGRFQForm')
      .then(element => {
        document.querySelector("#submitOMGRFQForm").onclick = function() {
          checkElementPresence('.omgrfq-submit-success')
          .then(element => {
            window.location.replace("https://legoodgoodies.fr/pages/merci");
          })
          .catch(error => {
            console.error(error.message);
          });
        };
      })
      .catch(error => {
        console.error(error.message);
      });
    }
  };
}else if (!!document.querySelector(".product .btn-ajouter-au-devis") === true){
  document.querySelector(".product .btn-ajouter-au-devis").onclick = function() {
    if (!document.querySelector(".product .btn-ajouter-au-devis:not([disabled])").hasAttribute('disabled')) {

      if ( !!document.querySelector(".product-form__input input[name=Taille]") === true || !!document.querySelector(".product-form__input input[name=Pointure]") === true ){
        var input = document.querySelectorAll('.product-form__input--pill label input[type="number"]');
        var i = 0;
        function processInput() {
          if (i == 0){
            document.head.insertAdjacentHTML('beforeend', '<style id="styleAppQuote">#app-quotes #quote-data{display: none !important;}*{cursor: wait !important;}.pop-up-loading{display: flex !important;}</style>');
          }
          if (i < input.length) {
            if (parseInt(input[i].value) > 0) {
              var qtyProduct = parseInt(input[i].value);
              document.querySelector(".product .product-form__input.product-form__quantity input.quantity__input").value = qtyProduct;
              var variantTitle = "";
              document.querySelectorAll('.product fieldset.product-form__input').forEach(function(fieldset) {
                if (fieldset.classList.contains("couleur-variants") === true) {
                  var nameOption = fieldset.querySelector("input:checked").value;
                } else {
                  var nameOption = input[i].parentElement.querySelector(".value").getAttribute("value");
                }
                variantTitle += nameOption + " / ";
              });
              variantTitle = variantTitle.slice(0, -3);
    
              var script = document.getElementById("data-product");
              var jsonText = script.textContent.trim();
              var jsonData = JSON.parse(jsonText);
    
              var idVariant = null;
              for (var j = 0; j < jsonData.offers.length; j++) {
                if (jsonData.offers[j].variantName === variantTitle) {
                  idVariant = jsonData.offers[j].idVariant;
                  break;
                }
              }
    
              document.querySelector('product-form.product-form form input[name="id"]').value = idVariant;
              var currentUrl = window.location.href;
              var updatedUrl = currentUrl.replace(/variant=\d+/, "variant=" + idVariant);
              history.replaceState(null, null, updatedUrl);
              document.querySelector(".product button.omgrfq-btn-quotes").click();
    
              setTimeout(function () {
                document.querySelector("html .omgrfq-popup.omgrfq-popup-snap .omgrfq_continue_shopping").click();
              }, 400);
    
            }
            i++;
            setTimeout(processInput, 800);
          }else{
            document.querySelector("#app-quotes #omgrfq_button_action_snap button.omgrfq_view_quote").click();
            document.querySelector("#styleAppQuote").remove();
            setTimeout(function () {
              addSecondaryBtn();
            }, 0);
            nbProduitPanier();
            setTimeout(function () {
              document.addEventListener('click', function(event) {
                if (event.target.closest('#quote-data')) {
                  setTimeout(function () {
                    nbProduitPanier();
                  }, 500);
                }
              });
            }, 500);
            
            checkElementPresence('#submitOMGRFQForm')
            .then(element => {
              document.querySelector("#submitOMGRFQForm").onclick = function() {
                checkElementPresence('.omgrfq-submit-success')
                .then(element => {
                  window.location.replace("https://legoodgoodies.fr/pages/merci");
                })
                .catch(error => {
                  console.error(error.message);
                });
              };
            })
            .catch(error => {
              console.error(error.message);
            });
          }
        }
        processInput();
      }else{
        document.querySelector(".product .omgrfq-btn-quotes").click();
        setTimeout(function () {
          addSecondaryBtn();
        }, 0);
      }
    }
  };
}



var width_screen = window.innerWidth;
if (width_screen > 750) {
  var splideElements = document.querySelectorAll('.splide.reassurance-slider');
  splideElements.forEach(function(element) {
    var splideElementsLengths = element.querySelectorAll('.splide__slide').length;
    if ( splideElementsLengths > 4 ){
      var splide = new Splide(element, {
        type: 'loop',
        autoplay: true,
        autoWidth: true,
        interval: 3000,
        pauseOnHover: true,
        focus: 'left',
        speed: 1000,
        arrows: true,
        perPage: 4,
        direction: 'ltr',
        gap: '20px',
        pagination: false,
        easing: 'cubic-bezier(0.7, 0.01, 0.27, 0.99)',
        drag: true,
        breakpoints: {
          750: {
            focus: 'center',
          }
        }
      });
      splide.mount();
    }
  });
} else {
  var splideElements = document.querySelectorAll('.splide.reassurance-slider');
  splideElements.forEach(function(element) {
    var splide = new Splide(element, {
      type: 'loop',
      autoplay: true,
      autoWidth: true,
      interval: 3000,
      pauseOnHover: true,
      focus: 'center',
      speed: 1000,
      arrows: true,
      perPage: 1,
      direction: 'ltr',
      gap: '20px',
      pagination: false,
      easing: 'cubic-bezier(0.7, 0.01, 0.27, 0.99)',
      drag: true
    });
    splide.mount();
  });
}




function createCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + value + expires + "; path=/";
}


function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

function onCrossClick() {
  document.querySelector(".pop-up-newsletter").style.cssText = "display: none !important;";
  createCookie('newsletter_no', 'true', 3);
}

if (getCookie('newsletter_no')) {
  document.querySelector(".pop-up-newsletter").style.cssText = "display: none !important;";
  document.querySelector('.croix-pop-up').addEventListener('click', onCrossClick);
}else{
  document.querySelector('.croix-pop-up').addEventListener('click', onCrossClick);
  document.querySelector(".pop-up-newsletter").onclick = function() {
    var element = this;
    if (!element.classList.contains("pop-up-newsletter")) {
      onCrossClick();
    }
  };
  setTimeout(function () {
    document.querySelector(".pop-up-newsletter").style.cssText = "display: flex;";
  }, 10000);
}

var urlParams = new URLSearchParams(window.location.search);
var variant = urlParams.get('customer_posted');
if ( variant == "true" ){
  onCrossClick();
}

var form_type = urlParams.get('form_type');
if ( form_type == "customer" ){
  document.querySelector("#ContactFooter").insertAdjacentHTML("beforeend", '<h3 class="newsletter-form__message newsletter-form__message--success form__message" id="ContactFooter-success" tabindex="-1" autofocus=""><svg aria-hidden="true" focusable="false" class="icon icon-success" viewBox="0 0 13 13"><path d="M6.5 12.35C9.73087 12.35 12.35 9.73086 12.35 6.5C12.35 3.26913 9.73087 0.65 6.5 0.65C3.26913 0.65 0.65 3.26913 0.65 6.5C0.65 9.73086 3.26913 12.35 6.5 12.35Z" fill="#428445" stroke="white" stroke-width="0.7"></path><path d="M5.53271 8.66357L9.25213 4.68197" stroke="white"></path><path d="M4.10645 6.7688L6.13766 8.62553" stroke="white"></path></svg>Vous êtes déjà inscrit !</h3>');
}


if (!!document.querySelector('.shopify-section.shopify-section-group-header-group.announcement-bar-section .utility-bar .announcement-bar__link[href="#POPUP"]') === true){
  document.querySelector('.shopify-section.shopify-section-group-header-group.announcement-bar-section .utility-bar .announcement-bar__link[href="#POPUP"]').onclick = function() {
    document.querySelector(".pop-up-newsletter").style.cssText = "display: flex;";
  };
}


document.querySelectorAll('#FacetsWrapperDesktop .facets__summary.checkbox-facet').forEach(function(summury) {
  summury.setAttribute("aria-expanded", "true");
});


if (!!document.querySelector("header.header header-menu details") === true){
  const detailsElements = document.querySelectorAll('header.header header-menu details');

  detailsElements.forEach(details => {
    const summary = details.querySelector('summary');

    summary.addEventListener('mouseenter', () => {
      details.setAttribute('open', true);
    });

    details.addEventListener('mouseleave', () => {
      details.removeAttribute('open');
    });
  });
}

/*var facetsSummary = document.querySelectorAll('html .facets__summary');
for (var i = 0; i < facetsSummary.length; i++) {
  facetsSummary[i].addEventListener('click', function(event) {
    document.querySelectorAll('#FacetsWrapperDesktop.facets__wrapper details:not([id*="fabrique-en-france"]):not([id*="eco-responsable"])').forEach(function(filtre) {
      if (filtre.hasAttribute("open")) {
        filtre.removeAttribute("open");
      }
    });
    var parent = event.currentTarget;
    if (parent.getAttribute("aria-expanded") == "false") {
      setTimeout(function () {
        parent.parentElement.removeAttribute("open");
      }, 50);
    }
  });
}*/

function ecoResponsableCheck() {
  if (!!document.querySelector('#FacetsWrapperMobile details[id*="eco-responsable"]') === true){
    setTimeout(function () {
      if (document.querySelector('#FacetsWrapperMobile details[id*="eco-responsable"] input.mobile-facets__checkbox').checked){
        if (!!document.querySelector(".style-eco-responsable") === false){
          document.head.insertAdjacentHTML('beforeend', "<style class='style-eco-responsable'>#FacetsWrapperMobile details[id*=eco-responsable] .mobile-facets__summary>div span:not(.mobile-facets__arrow):before{content: url(\"data:image/svg+xml; utf8, %3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0_2791_4)'%3E%3Cpath d='M16 0H0V16H16V0Z' stroke='white' stroke-width='1.2'/%3E%3Cg clip-path='url(%23clip1_2791_4)'%3E%3Cpath d='M4.5 7.5L5.83333 8.75L7.16667 10L12.5 5' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/g%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_2791_4'%3E%3Crect width='16' height='16' fill='white'/%3E%3C/clipPath%3E%3CclipPath id='clip1_2791_4'%3E%3Crect width='11' height='7' fill='white' transform='translate(3 4)'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A\");}</style>");
        }
      }else{
        if (!!document.querySelector(".style-eco-responsable") === true){
          document.querySelector(".style-eco-responsable").remove();
        }
      }
    }, 1500);
  }
}
ecoResponsableCheck();

if (!!document.querySelector('#FacetsWrapperMobile details[id*="eco-responsable"]') === true){
  document.querySelector('#FacetsWrapperMobile details[id*="eco-responsable"]').onclick = function() {
    document.querySelector('#FacetsWrapperMobile details[id*="eco-responsable"] .facets__label').click();
    ecoResponsableCheck();
  };
}

function resizeWindow(event) {
  let width = window.innerWidth;
  if (width > 1400 && !document.querySelector('details-modal.header__search details').hasAttribute("open") ){
    document.querySelector('details-modal.header__search details').setAttribute("open", "true");
  }
}
resizeWindow();

window.addEventListener('resize', function() {
  resizeWindow();
});



function fabriqueFranceCheck() {
  if (!!document.querySelector('#FacetsWrapperMobile details[id*="fabrique-en-france"]') === true){
    setTimeout(function () {
      if (document.querySelector('#FacetsWrapperMobile details[id*="fabrique-en-france"] input.mobile-facets__checkbox').checked){
        if (!!document.querySelector(".style-fabrique-en-france") === false){
          document.head.insertAdjacentHTML('beforeend', "<style class='style-fabrique-en-france'>#FacetsWrapperMobile details[id*=fabrique-en-france] .mobile-facets__summary>div span:not(.mobile-facets__arrow):before{content: url(\"data:image/svg+xml; utf8, %3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0_2791_4)'%3E%3Cpath d='M16 0H0V16H16V0Z' stroke='white' stroke-width='1.2'/%3E%3Cg clip-path='url(%23clip1_2791_4)'%3E%3Cpath d='M4.5 7.5L5.83333 8.75L7.16667 10L12.5 5' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/g%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_2791_4'%3E%3Crect width='16' height='16' fill='white'/%3E%3C/clipPath%3E%3CclipPath id='clip1_2791_4'%3E%3Crect width='11' height='7' fill='white' transform='translate(3 4)'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A\");}</style>");
        }
      }else{
        if (!!document.querySelector(".style-fabrique-en-france") === true){
          document.querySelector(".style-fabrique-en-france").remove();
        }
      }
    }, 1500);
  }
}
fabriqueFranceCheck();

if (!!document.querySelector('#FacetsWrapperMobile details[id*="fabrique-en-france"]') === true){
  document.querySelector('#FacetsWrapperMobile details[id*="fabrique-en-france"]').onclick = function() {
    document.querySelector('#FacetsWrapperMobile details[id*="fabrique-en-france"] .facets__label').click();
    fabriqueFranceCheck();
  };
}


/*if (window.location.href.includes('pages/contact')){
  window.addEventListener("load", (event) => {
    let attempts = 10; // 5 secondes / 500ms = 10 tentatives
    const checkElement = setInterval(() => {
      const formEmbed = document.querySelector('#app-embed');
      if (formEmbed && formEmbed.shadowRoot || attempts <= 0) {
        const style = document.createElement('style');
        style.textContent = `
        #form-container-ref section[data-sizing="form-wrapper"]{
          max-width: 800px;
        }
        #form-container-ref section[data-sizing="form-wrapper"] form{
        flex-direction: row;
        flex-wrap: wrap;
        gap: 2rem;
        }
        #form-container-ref section[data-sizing="form-wrapper"] form>div{
        width: 100%;
        }
        #form-container-ref section[data-sizing="form-wrapper"] form>div:first-child, #form-container-ref section[data-sizing="form-wrapper"] form>div:nth-child(2), #form-container-ref section[data-sizing="form-wrapper"] form>div:nth-child(3), #form-container-ref section[data-sizing="form-wrapper"] form>div:nth-child(4), #form-container-ref section[data-sizing="form-wrapper"] form>div:nth-child(7),#form-container-ref section[data-sizing="form-wrapper"] form>div:nth-child(8){
          width: calc(50% - 1rem);
        }
        #form-container-ref fieldset{
            width: 100%;
        }
        #form-container-ref fieldset>div{
          flex-flow: row;
          flex-wrap: wrap;
        }
        #form-container-ref fieldset>div label{
          width: calc(25% - 32px);
          background-color: transparent;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 10px;
          border: 2px solid rgb(242, 232, 219);
          cursor: pointer;
        }
        #form-container-ref legend, #form-container-ref p{
          color: #dbaf94;
          text-transform: uppercase;
          font-weight: 600;
        }
        #form-container-ref fieldset>div label:has(input:checked){
        background-color: rgb(242, 232, 219);
        }
        #form-container-ref fieldset>div label span{
        text-align: center;
        }
        #form-container-ref fieldset>div label input{
          display: none;
        }
        #form-container-ref [aria-controls*="dropdown"], #form-container-ref input, #form-container-ref textarea, #form-container-ref button[aria-controls="country-selector-dropdown"]{
          background-color: rgb(242, 232, 219);
          border: none !important;
          box-shadow: none !important;
          border-radius: 0px !important;
          padding-top: 21px;
          line-height: 1 !important;
          height: 100%;
          min-height: 28px !important;
          height: 28px !important;
          max-height: 28px !important;
        }
        
        #form-container-ref label{
          color: #dbaf94;
          text-transform: uppercase;
          font-weight: 600;
        }
        #form-container-ref section[data-sizing="form-wrapper"] form>div:nth-child(9) p{
        position: absolute;
        z-index: 2;
        top: 7px;
        left: 13px;
        }
        #form-container-ref section[data-sizing="form-wrapper"] form>div:nth-child(9) button{
            padding-top: 30px;
          padding-bottom: 27px;
        }
        #form-container-ref section[data-sizing="form-wrapper"] form>div:nth-child(4) button{
          padding-top: 0;
          padding-bottom: 0;
          height: 56px !important;
          min-height: 56px !important;
        }
        #form-container-ref section[data-sizing="form-wrapper"] form>div:nth-child(4) button span img{
          transform: translateY(20px);
        }
        #form-container-ref textarea{
            min-height: 70px !important;
        }
        button[data-testid="btn-form-submit"]{
          background-color: #000;
          text-transform: uppercase;
          border-radius: 0;
          font-weight: 700;
          font-size: 16px;
          padding: 15px 30px;
          margin-left: auto;
        }
    
        #form-container-ref section[data-sizing="form-wrapper"] form>button{
          background-color: #000;
          text-transform: uppercase;
          font-weight: 700;
          font-size: 16px;
          border-radius: 0;
          padding: 15px 30px;
          margin-left: auto;
        }
        #form-container-ref section[data-sizing="form-wrapper"] form>div:nth-child(9) button span:last-child{
          transform: translateY(-10px);
        }
        @media screen and (max-width: 670px){
          #form-container-ref section[data-sizing="form-wrapper"] form>div{
            width: 100% !important;
          }
          #form-container-ref fieldset>div label{
            width: calc(50% - 29.3px);
          }
    
          #form-container-ref section[data-sizing="form-wrapper"] form>div:nth-child(5) input{
            min-height: 58px !important;
            height: 58px !important;
            max-height: 58px !important;
          }
        }
        `;
        formEmbed.shadowRoot.appendChild(style);
       clearInterval(checkElement);
      }
      attempts--;
    }, 500);
  });
}*/


window.addEventListener("load", (event) => {
  if (window.location.href.includes('pages/contact')){
    setTimeout(function () {
      const formEmbed = document.querySelector('#app-embed');
      if (formEmbed && formEmbed.shadowRoot) {
        const style = document.createElement('style');
        style.textContent = `
        button[data-testid="btn-form-submit"]{
          background-color: #618f6a !important;
          border-radius: 0 !important;
          font-size: 15px !important;
          font-weight: 600 !important;
        }

        section>h2+div>p:first-child{
          margin-bottom: 10px;
          text-align: left;
          font-size: 24px;
          line-height: 1;
        }

        input[id*="pour_quelle_occasion"]{
          min-height: 70px !important;
        }

        input[id*="pour_quelle_occasion"]+label{
          top: 12.5px !important;
          line-height: 1.5;
        }

        section>h2+div>p:nth-child(2){
          text-align: left;
        }

        fieldset legend{
          margin-top: 10px !important;
          display: block !important;
          font-weight: 600 !important;
          font-size: 16px !important;
          line-height: 1.5 !important;
        }

        input[type="radio"]{
          accent-color: #000 !important;
        }

        fieldset[name*="recevoir"] legend{
          font-weight: 400 !important;
          font-size: 14px !important;
        }

        fieldset[name*="recevoir"]>legend+div{
          flex-direction: row;
          gap: 30px;
          margin-bottom: 10px;
        }

        @media screen and (max-width: 880px){
          section>h2+div>p:first-child{
            font-size: 20px;
            line-height: 1.3;
          }
        }
        `;
        formEmbed.shadowRoot.appendChild(style);
      }
      document.head.insertAdjacentHTML('beforeend', '<style>#app-embed{opacity: 1 !important;}</style>');
    }, 300);
  } /*else if (window.location.href.includes('pages/contact')){
    setTimeout(function () {
      const formEmbed = document.querySelector('#app-embed');
      if (formEmbed && formEmbed.shadowRoot) {
        const style = document.createElement('style');
        style.textContent = `
        #form-container-ref section[data-sizing="form-wrapper"]{
          max-width: 800px;
        }
        #form-container-ref section[data-sizing="form-wrapper"] form{
        flex-direction: row;
        flex-wrap: wrap;
        gap: 2rem;
        }
        #form-container-ref section[data-sizing="form-wrapper"] form>div{
        width: 100%;
        }
        #form-container-ref section[data-sizing="form-wrapper"] form>div:first-child, #form-container-ref section[data-sizing="form-wrapper"] form>div:nth-child(2), #form-container-ref section[data-sizing="form-wrapper"] form>div:nth-child(3), #form-container-ref section[data-sizing="form-wrapper"] form>div:nth-child(4), #form-container-ref section[data-sizing="form-wrapper"] form>div:nth-child(7),#form-container-ref section[data-sizing="form-wrapper"] form>div:nth-child(8){
          width: calc(50% - 1rem);
        }
        #form-container-ref fieldset{
            width: 100%;
        }
        #form-container-ref fieldset>div{
          flex-flow: row;
          flex-wrap: wrap;
        }
        #form-container-ref fieldset>div label{
          width: calc(25% - 32px);
          background-color: transparent;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 10px;
          border: 2px solid rgb(242, 232, 219);
          cursor: pointer;
        }
        #form-container-ref legend, #form-container-ref p{
          color: #dbaf94;
          text-transform: uppercase;
          font-weight: 600;
        }
        #form-container-ref fieldset>div label:has(input:checked){
        background-color: rgb(242, 232, 219);
        }
        #form-container-ref fieldset>div label span{
        text-align: center;
        }
        #form-container-ref fieldset>div label input{
          display: none;
        }
        #form-container-ref [aria-controls*="dropdown"], #form-container-ref input, #form-container-ref textarea, #form-container-ref button[aria-controls="country-selector-dropdown"]{
          background-color: rgb(242, 232, 219);
          border: none !important;
          box-shadow: none !important;
          border-radius: 0px !important;
          padding-top: 21px;
          line-height: 1 !important;
          height: 100%;
          min-height: 28px !important;
          height: 28px !important;
          max-height: 28px !important;
        }
        
        #form-container-ref label{
          color: #dbaf94;
          text-transform: uppercase;
          font-weight: 600;
        }
        #form-container-ref section[data-sizing="form-wrapper"] form>div:nth-child(9) p{
        position: absolute;
        z-index: 2;
        top: 7px;
        left: 13px;
        }
        #form-container-ref section[data-sizing="form-wrapper"] form>div:nth-child(9) button{
            padding-top: 30px;
          padding-bottom: 27px;
        }
        #form-container-ref section[data-sizing="form-wrapper"] form>div:nth-child(4) button{
          padding-top: 0;
          padding-bottom: 0;
          height: 56px !important;
          min-height: 56px !important;
        }
        #form-container-ref section[data-sizing="form-wrapper"] form>div:nth-child(4) button span img{
          transform: translateY(20px);
        }
        #form-container-ref textarea{
            min-height: 70px !important;
        }
        button[data-testid="btn-form-submit"]{
          background-color: #000;
          text-transform: uppercase;
          border-radius: 0;
          font-weight: 700;
          font-size: 16px;
          padding: 15px 30px;
          margin-left: auto;
        }
    
        #form-container-ref section[data-sizing="form-wrapper"] form>button{
          background-color: #000;
          text-transform: uppercase;
          font-weight: 700;
          font-size: 16px;
          border-radius: 0;
          padding: 15px 30px;
          margin-left: auto;
        }
        #form-container-ref section[data-sizing="form-wrapper"] form>div:nth-child(9) button span:last-child{
          transform: translateY(-10px);
        }
        @media screen and (max-width: 670px){
          #form-container-ref section[data-sizing="form-wrapper"] form>div{
            width: 100% !important;
          }
          #form-container-ref fieldset>div label{
            width: calc(50% - 29.3px);
          }
    
          #form-container-ref section[data-sizing="form-wrapper"] form>div:nth-child(5) input{
            min-height: 58px !important;
            height: 58px !important;
            max-height: 58px !important;
          }
        }
        `;
        formEmbed.shadowRoot.appendChild(style);
      }
      document.head.insertAdjacentHTML('beforeend', '<style>#app-embed{opacity: 1 !important;}</style>');
    }, 300);
  }*/
});



document.addEventListener('DOMContentLoaded', function() {
  const menuItems = document.querySelectorAll('.menu-droite li');
  let currentHoveredItem = null;
  let removeTimeout = null;
  let isMenuOpen = false;
  let pendingItem = null; // Nouvel item en attente

  menuItems.forEach(item => {
    const megaMenu = item.querySelector('.mega-sous-menu');
    
    if (megaMenu) {
      // Au survol du li
      item.addEventListener('mouseenter', function() {
        // Si un menu est déjà ouvert et que ce n'est pas le même item
        if (isMenuOpen && currentHoveredItem !== item) {
          // Stocker l'item en attente
          pendingItem = item;
          
          // Si pas de timer en cours, démarrer la transition
          if (!removeTimeout) {
            startTransition();
          }
          return;
        }
        
        // Annuler le timeout de suppression si il existe
        if (removeTimeout) {
          clearTimeout(removeTimeout);
          removeTimeout = null;
          pendingItem = null;
        }
        
        // Fermer le menu précédent s'il existe
        if (currentHoveredItem && currentHoveredItem !== item) {
          const currentMegaMenu = currentHoveredItem.querySelector('.mega-sous-menu');
          if (currentMegaMenu) {
            currentMegaMenu.classList.remove('hover');
          }
        }
        
        // Ouvrir le nouveau menu
        megaMenu.classList.add('hover');
        currentHoveredItem = item;
        isMenuOpen = true;
        pendingItem = null;
      });
      
      // Quand on quitte le li
      item.addEventListener('mouseleave', function() {
        // Si c'est l'item en attente qui est quitté, l'annuler
        if (pendingItem === item) {
          pendingItem = null;
          return;
        }
        
        // Délai court pour vérifier si on va vers le mega-menu
        setTimeout(() => {
          checkIfShouldClose();
        }, 50);
      });
      
      // Maintenir ouvert si on survole le mega-menu
      megaMenu.addEventListener('mouseenter', function() {
        if (removeTimeout) {
          clearTimeout(removeTimeout);
          removeTimeout = null;
          pendingItem = null;
        }
      });
      
      // Quand on quitte le mega-menu
      megaMenu.addEventListener('mouseleave', function() {
        setTimeout(() => {
          checkIfShouldClose();
        }, 50);
      });
    }
  });
  
  function startTransition() {
    if (removeTimeout) {
      clearTimeout(removeTimeout);
    }
    
    removeTimeout = setTimeout(() => {
      // Fermer le menu actuel
      if (currentHoveredItem) {
        const currentMegaMenu = currentHoveredItem.querySelector('.mega-sous-menu');
        if (currentMegaMenu) {
          currentMegaMenu.classList.remove('hover');
        }
      }
      
      // Ouvrir le nouveau menu si l'item est encore survolé
      if (pendingItem && pendingItem.matches(':hover')) {
        const newMegaMenu = pendingItem.querySelector('.mega-sous-menu');
        if (newMegaMenu) {
          newMegaMenu.classList.add('hover');
          currentHoveredItem = pendingItem;
          isMenuOpen = true;
        }
      } else {
        currentHoveredItem = null;
        isMenuOpen = false;
      }
      
      pendingItem = null;
      removeTimeout = null;
    }, 300);
  }
  
  function checkIfShouldClose() {
    if (!currentHoveredItem) return;
    
    const item = currentHoveredItem;
    const megaMenu = item.querySelector('.mega-sous-menu');
    
    // Si on survole encore le li OU le mega-menu, on ne ferme pas
    if (item.matches(':hover') || megaMenu.matches(':hover')) {
      return;
    }
    
    // Si il n'y a pas d'item en attente, fermer normalement
    if (!pendingItem) {
      startCloseTimer();
    }
  }
  
  function startCloseTimer() {
    if (removeTimeout) {
      clearTimeout(removeTimeout);
    }
    
    removeTimeout = setTimeout(() => {
      if (currentHoveredItem) {
        const item = currentHoveredItem;
        const megaMenu = item.querySelector('.mega-sous-menu');
        
        // Double vérification avant de fermer
        if (!item.matches(':hover') && !megaMenu.matches(':hover')) {
          megaMenu.classList.remove('hover');
          currentHoveredItem = null;
          isMenuOpen = false;
        }
      }
      removeTimeout = null;
    }, 300);
  }
});






















document.addEventListener('DOMContentLoaded', function() {
  const wrapper = document.querySelector('.wrapper-menu-droite');
  if (wrapper){
    const fleches = wrapper.querySelectorAll('.fleche');
    const flecheGauche = fleches[0];
    const flecheDroite = fleches[1];
    const scrollAmount = 200;

    function updateFleches() {
      const scrollLeft = wrapper.scrollLeft;
      const scrollWidth = wrapper.scrollWidth;
      const clientWidth = wrapper.clientWidth;
      const maxScroll = scrollWidth - clientWidth;

      console.log('scrollLeft:', scrollLeft);
      console.log('scrollWidth:', scrollWidth);
      console.log('clientWidth:', clientWidth);
      console.log('maxScroll:', maxScroll);
      console.log('---');

      // Si le contenu n'est pas scrollable, cacher les deux flèches
      if (maxScroll <= 1) {
        flecheGauche.style.opacity = '0';
        flecheGauche.style.pointerEvents = 'none';
        flecheDroite.style.opacity = '0';
        flecheDroite.style.pointerEvents = 'none';
        console.log('Contenu non scrollable - flèches cachées');
        return;
      }

      // Flèche gauche - masquer si au début
      if (scrollLeft <= 1) {
        flecheGauche.style.opacity = '0';
        flecheGauche.style.pointerEvents = 'none';
        console.log('Scroll tout à GAUCHE - flèche gauche cachée');
      } else {
        flecheGauche.style.opacity = '1';
        flecheGauche.style.pointerEvents = 'auto';
      }

      // Flèche droite - masquer si à la fin
      if (scrollLeft >= maxScroll - 1) {
        flecheDroite.style.opacity = '0';
        flecheDroite.style.pointerEvents = 'none';
        console.log('Scroll tout à DROITE - flèche droite cachée');
      } else {
        flecheDroite.style.opacity = '1';
        flecheDroite.style.pointerEvents = 'auto';
      }
    }

    flecheGauche.addEventListener('click', function() {
      console.log('Clic flèche gauche');
      wrapper.scrollBy({
        left: -scrollAmount,
        behavior: 'smooth'
      });
    });

    flecheDroite.addEventListener('click', function() {
      console.log('Clic flèche droite');
      wrapper.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      });
    });

    wrapper.addEventListener('scroll', function() {
      console.log('EVENT SCROLL détecté');
      updateFleches();
    });
    
    window.addEventListener('resize', updateFleches);

    setTimeout(updateFleches, 100);
  }




  document.querySelectorAll('.inline-richtext[telechargement]').forEach(function(element) {    
    element.addEventListener('click', function(e) {
      e.preventDefault();
      const fileUrl = this.getAttribute('telechargement');
      if (fileUrl) {
        const link = document.createElement('a');
        link.href = fileUrl;
        link.download = '';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    });
  });
});